import "./styles.css";
import { Route, Routes } from "react-router-dom";
import Home from "./routes/Home"
import About from "./routes/About"
import Service from "./routes/Service"
import Navbar from "./components/navbar/Navbar"

export default function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Service />} />
      </Routes>
    </div>
  );
}
